import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDateRangeRequestParams } from "Dashboard/domain/IDateRangeRequestParams";
import { RootState } from "reducers";
import { IResourceRefuel } from "../domain/IResourceRefuel";
import { DailyTableService } from "../services/dt.service";

interface dtRefuelsState {
  loading: boolean;
  refuels: IResourceRefuel[];
  error: any;
}

const initialState: dtRefuelsState = {
  loading: false,
  refuels: [],
  error: undefined,
};

export const getBasicDataForRefuelsOfResources = createAsyncThunk(
  "DailyTable/getBasicDataForRefuelsOfResources",
  async (data?: IDateRangeRequestParams) => {
    try {
      const result = await DailyTableService.getBasicDataForRefuelsOfResources(
        data
      );
      return result.refuels;
    } catch (err) {
      setError(err);
    }
  }
);

export const dtRefuelsSlice = createSlice({
  name: "Refuels",
  initialState: initialState,
  reducers: {
    setRefuels: (state, action: PayloadAction<IResourceRefuel[]>) => {
      state.refuels = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBasicDataForRefuelsOfResources.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getBasicDataForRefuelsOfResources.fulfilled,
      (state, action) => {
        state.refuels = action.payload ? action.payload : [];
        state.loading = false;
      }
    );
    builder.addCase(
      getBasicDataForRefuelsOfResources.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    );
  },
});

export const selectState = (state: RootState) => state.dailytable.refuels;

export const { setError } = dtRefuelsSlice.actions;

export default dtRefuelsSlice.reducer;
